import { IChatCustom, IContact } from '@interfaces/chat/chatI';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';


export const chatSocketStateSlice = createSlice({
    name: 'chatSocketState',
    initialState: {
        chats: [],
        contacts: [],
    } as {chats: IChatCustom[], contacts: IContact[]},
    reducers:{
        setChatSocketState: (state, action: PayloadAction<IChatCustom[]>) => {            
            state.chats = action.payload
        },
        setContactsSocketState: (state, action: PayloadAction<IContact[]>) => {            
            state.contacts = action.payload
        }
    }
});

export const {setChatSocketState, setContactsSocketState} = chatSocketStateSlice.actions;
export default chatSocketStateSlice.reducer;